module.exports = __webpack_public_path__ + "img/product_103.4be38ce.webp";